<template>
  <div>
    <form id="formConsulta" @submit.prevent="onSubmit()">
      <section class="filter d-flex justify-content-center">
        <div class="form-outline mt-3">
          <input type="text" class="form-control" v-model="codCorretor" />
          <label class="form-label">Código Corretor</label>
          <!-- manter essa div para nao dar erro de JS no select -->
          <div class="form-notch">
            <div class="form-notch-leading"></div>
            <div class="form-notch-middle"></div>
            <div class="form-notch-trailing"></div>
          </div>
        </div>
        <button type="submit" class="btn btn-primary btn-pesquisar" title="Pesquisar">
          <i class="fa-solid fa-search"></i>
        </button>
      </section>
    </form>
    <section class="lista-corretor" v-if="categoryData">
      <div class="container">
        <h1>LISTA DE INTEGRAÇÕES</h1>
        <hr class="divider">

        <!-- inicio do for -->
        <div v-for="(items, codigoProduto) in categoryData" :key="codigoProduto">

          <!-- auto -->
          <div v-if="codigoProduto == 7" class="row d-flex justify-content-center">
            <div class="col-12 col-md-12 col-lg-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_auto.svg" alt="" title="">
                      <h1>AUTOMÓVEL</h1>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>OPERADORA(S):</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.operadora }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>INTEGRADO DESDE:</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.inicioVigencia }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- residencial -->
          <div v-if="codigoProduto == 14" class="row d-flex justify-content-center">
            <div class="col-12 col-md-12 col-lg-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_residencial.svg" alt="" title="">
                      <h1>RESIDENCIAL</h1>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>OPERADORA(S):</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.operadora }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>INTEGRADO DESDE:</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.inicioVigencia }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- imobiliário -->
          <div v-if="codigoProduto == 43" class="row d-flex justify-content-center">
            <div class="col-12 col-md-12 col-lg-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_imobiliario.svg" alt="" title="">
                      <h1>IMOBILIÁRIO</h1>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>OPERADORA(S):</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.operadora }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>INTEGRADO DESDE:</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.inicioVigencia }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- condominio -->
          <div v-if="codigoProduto == 12" class="row d-flex justify-content-center">
            <div class="col-12 col-md-12 col-lg-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_condominio.svg" alt="" title="">
                      <h1>CONDOMÍNIO</h1>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>OPERADORA(S):</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.operadora }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>INTEGRADO DESDE:</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.inicioVigencia }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- vida -->
          <div v-if="codigoProduto == 47" class="row d-flex justify-content-center">
            <div class="col-12 col-md-12 col-lg-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_vida.svg" alt="" title="">
                      <h1>VIDA</h1>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>OPERADORA(S):</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.operadora }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>INTEGRADO DESDE:</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.inicioVigencia }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- aluguel -->
          <div v-if="codigoProduto == 72" class="row d-flex justify-content-center">
            <div class="col-12 col-md-12 col-lg-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_aluguel.svg" alt="" title="">
                      <h1>ALUGUEL</h1>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>OPERADORA(S):</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.operadora }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>INTEGRADO DESDE:</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.inicioVigencia }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- garantia -->
          <div v-if="codigoProduto == 7603" class="row d-flex justify-content-center">
            <div class="col-12 col-md-12 col-lg-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_garantia.svg" alt="" title="">
                      <h1>GARANTIA</h1>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>OPERADORA(S):</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.operadora }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>INTEGRADO DESDE:</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.inicioVigencia }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- empresarial -->
          <div v-if="codigoProduto == 62" class="row d-flex justify-content-center">
            <div class="col-12 col-md-12 col-lg-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_empresarial.svg" alt="" title="">
                      <h1>EMPRESARIAL</h1>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>OPERADORA(S):</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.operadora }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>INTEGRADO DESDE:</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.inicioVigencia }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- agro -->
          <div v-if="codigoProduto == 103" class="row d-flex justify-content-center">
            <div class="col-12 col-md-12 col-lg-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_agro.svg" alt="" title="">
                      <h1>AGRO SAFRA</h1>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>OPERADORA(S):</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.operadora }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>INTEGRADO DESDE:</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.inicioVigencia }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- equipamentos -->
          <div v-if="codigoProduto == 10005" class="row d-flex justify-content-center">
            <div class="col-12 col-md-12 col-lg-8">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-md-4">
                      <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_equipamentos.svg" alt="" title="">
                      <h1>EQUIPAMENTOS</h1>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>OPERADORA(S):</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.operadora }}
                        </li>
                      </ul>
                    </div>
                    <div class="col-6 col-md-4">
                      <ul>
                        <li>INTEGRADO DESDE:</li>
                        <li v-for="(item, index) in items" :key="index">
                          {{ item.inicioVigencia }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <div class="list">
      <div v-if="categoryData">
        <div v-for="(items, codigoProduto) in categoryData" :key="codigoProduto">
          <div>
            <h6 style="text-transform: uppercase;"><strong>PRODUTO:</strong> {{ codigoProduto }} - {{ items[0].produto }}
            </h6>
            <ul>
              <li v-for="(item, index) in items" :key="index">
                <strong>Operadora:</strong> {{ item.operadora }}<br>
                <strong>Início de vigência:</strong> {{ item.inicioVigencia }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader';
export default {
  data() {
    return {
      categoryData: null,
      codCorretor: ''
    };
  },
  mounted() {
    document.querySelector("body").classList.remove("consulta-operadora");
    document.querySelector("body").classList.add("consulta");
  },
  computed: {

  }, 
  methods: {
  onSubmit() {
    if (this.codCorretor == "") {
      alertUtils.alertError("Informe um código de corretor para realizar a pesquisa!");
    } else {
      this.fetchData(this.codCorretor, "");
      /*
      this.obterToken()
        .then((token) => {
          this.fetchData(this.codCorretor, token);
        })
        .catch((error) => {
          loaderUtils.removeLoader();
          alertUtils.alertError('Erro na autenticação:', error);
        });
      */
    }
  },

  obterToken() {
    return "token";
  },
  /*
  obterToken() {
    const urlAutenticacao = 'https://apis.tokiomarine.com.br/invoke/pub.apigateway.oauth2/getAccessToken';
    const dadosAutenticacao = {
      client_id: '950cef86-22e2-43cd-8456-2fe31378e61d',
      client_secret: '6d7e6330-adc4-4e6a-b7d3-5a43bc97a877',
      grant_type: 'client_credentials',
    };

    const formData = new FormData();
    for (const key in dadosAutenticacao) {
      formData.append(key, dadosAutenticacao[key]);
    }

    const requestOptions = {
      method: 'GET',
    };

    const urlComParametros = `${urlAutenticacao}?${new URLSearchParams(formData).toString()}`;

    return fetch(urlComParametros, requestOptions)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Erro na obtenção do token');
        }
      })
      .then((data) => {
        return data.access_token;
      });
  },
  */

  fetchData(cod, token) {
    loaderUtils.addLoarder();
    //const urlApi = 'https://apis.tokiomarine.com.br/gateway/gerenciador-parceiros/v1/rest/corretor/adesoes/' + cod;
    const urlApi = 'https://servicos.tokiomarine.com.br/massificados/corporativo/gerenciador-parceiros/rest/corretor/adesoes/' + cod;
    const requestOptions = {
      method: 'GET',
      //headers: {
      //  Authorization: `Bearer ${token}`,
      //},
    };
    
    fetch(urlApi, requestOptions)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 404) {
          alertUtils.alertError("Código de corretor não encontrado!");
          this.categoryData = null;
        } else {
          throw new Error('Erro na solicitação à API');
        }
      })
      .then((data) => {
        this.processarDados(data);
      })
      .catch((error) => {
        loaderUtils.removeLoader();
        alertUtils.alertError('Erro na requisição:', error);
      })
      .finally(() => loaderUtils.removeLoader());
  },

  processarDados(data) {
    if (data.length === 2) {
      document.querySelector('body').classList.add('consulta');
      document.querySelector('body').classList.remove('consulta-corretor');
    } else {
      document.querySelector('body').classList.remove('consulta');
      document.querySelector('body').classList.add('consulta-corretor');
    }

    this.categoryData = data.reduce((result, item) => {
      const itemCategory = item.codigoProduto;
      if (!result[itemCategory]) {
        result[itemCategory] = [];
      }
      result[itemCategory].push(item);
      return result;
    }, {});
  },
},
};
</script>